function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "46",
  height: "33",
  fill: "none"
}, props), /*#__PURE__*/React.createElement("use", {
  href: "#j",
  fill: "url(#A)"
}), /*#__PURE__*/React.createElement("use", {
  href: "#j",
  fill: "url(#B)"
}), /*#__PURE__*/React.createElement("use", {
  href: "#j",
  fill: "url(#C)"
}), /*#__PURE__*/React.createElement("use", {
  href: "#j",
  fill: "url(#D)"
}), /*#__PURE__*/React.createElement("use", {
  href: "#j",
  fill: "url(#E)"
}), /*#__PURE__*/React.createElement("use", {
  href: "#j",
  fill: "url(#F)"
}), /*#__PURE__*/React.createElement("use", {
  href: "#j",
  fill: "url(#G)"
}), /*#__PURE__*/React.createElement("use", {
  href: "#j",
  fill: "url(#H)"
}), /*#__PURE__*/React.createElement("use", {
  href: "#j",
  fill: "url(#I)"
}), /*#__PURE__*/React.createElement("use", {
  href: "#j",
  fill: "url(#J)"
}), /*#__PURE__*/React.createElement("use", {
  href: "#j",
  fill: "url(#K)"
}), /*#__PURE__*/React.createElement("use", {
  href: "#j",
  fill: "url(#L)"
}), /*#__PURE__*/React.createElement("use", {
  href: "#j",
  fill: "url(#M)"
}), /*#__PURE__*/React.createElement("use", {
  href: "#j",
  fill: "url(#N)"
}), /*#__PURE__*/React.createElement("use", {
  href: "#j",
  fill: "url(#O)"
}), /*#__PURE__*/React.createElement("use", {
  href: "#j",
  fill: "url(#P)"
}), /*#__PURE__*/React.createElement("use", {
  href: "#j",
  fill: "url(#Q)"
}), /*#__PURE__*/React.createElement("use", {
  href: "#j",
  fill: "url(#R)"
}), /*#__PURE__*/React.createElement("use", {
  href: "#j",
  fill: "url(#S)"
}), /*#__PURE__*/React.createElement("use", {
  href: "#j",
  fill: "url(#T)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.014 12.03l2.952-7.882a10.35 10.35 0 013.652-3.045A10.357 10.357 0 0131.247.014C33.56 0 35.809.774 37.623 2.21c3.036 2.298 4.844 6.823 4.844 6.823a4.57 4.57 0 01.398 1.873 4.55 4.55 0 01-.35 1.741 4.548 4.548 0 01-.99 1.475 4.55 4.55 0 01-3.221 1.326 4.547 4.547 0 01-3.483-1.633l-.043-.053a6.077 6.077 0 01-.724-1.274 17.681 17.681 0 00-.84-1.66 10.53 10.53 0 00-.536-.801 3.312 3.312 0 00-.572-.628c-.427-.345-.965-.483-1.467-.186a.65.65 0 00-.07.046c-.517.355-.878 1.072-1.13 1.622-.724 1.559-1.139 3.157-1.549 4.798l-.227.951-1.919 6.275-5.73-10.872z",
  fill: "url(#U)"
}), /*#__PURE__*/React.createElement("use", {
  href: "#k",
  fill: "url(#V)"
}), /*#__PURE__*/React.createElement("use", {
  href: "#k",
  fill: "url(#W)"
}), /*#__PURE__*/React.createElement("use", {
  href: "#k",
  fill: "url(#X)"
}), /*#__PURE__*/React.createElement("use", {
  href: "#k",
  fill: "url(#Y)"
}), /*#__PURE__*/React.createElement("use", {
  href: "#k",
  fill: "url(#Z)"
}), /*#__PURE__*/React.createElement("use", {
  href: "#k",
  fill: "url(#a)"
}), /*#__PURE__*/React.createElement("use", {
  href: "#k",
  fill: "url(#b)"
}), /*#__PURE__*/React.createElement("use", {
  href: "#k",
  fill: "url(#c)"
}), /*#__PURE__*/React.createElement("use", {
  href: "#k",
  fill: "url(#d)"
}), /*#__PURE__*/React.createElement("use", {
  href: "#k",
  fill: "url(#e)"
}), /*#__PURE__*/React.createElement("use", {
  href: "#k",
  fill: "url(#f)"
}), /*#__PURE__*/React.createElement("use", {
  href: "#k",
  fill: "url(#g)"
}), /*#__PURE__*/React.createElement("use", {
  href: "#k",
  fill: "url(#h)"
}), /*#__PURE__*/React.createElement("use", {
  href: "#k",
  fill: "url(#i)"
}), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
  id: "B",
  cx: "0",
  cy: "0",
  r: "1",
  gradientTransform: "matrix(4.6213 16.46287 -12.5118 3.5122 25.877 13.74)",
  href: "#l"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#227b60"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".14",
  stopColor: "#227b60",
  stopOpacity: ".81"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".58",
  stopColor: "#227b60",
  stopOpacity: ".23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".78",
  stopColor: "#227b60",
  stopOpacity: "0"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "C",
  cx: "0",
  cy: "0",
  r: "1",
  gradientTransform: "matrix(-.23122 11.56039 -8.78465 -.1757 28.357 12.551)",
  href: "#l"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#227b60"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".25",
  stopColor: "#227b60",
  stopOpacity: ".7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".71",
  stopColor: "#227b60",
  stopOpacity: ".2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".92",
  stopColor: "#227b60",
  stopOpacity: "0"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "D",
  cx: "0",
  cy: "0",
  r: "1",
  gradientTransform: "rotate(88.6 7.308 20.789) scale(10.7784 7.65265)",
  href: "#l"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#227b60"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".07",
  stopColor: "#227b60",
  stopOpacity: ".9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".34",
  stopColor: "#227b60",
  stopOpacity: ".51"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".59",
  stopColor: "#227b60",
  stopOpacity: ".23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".79",
  stopColor: "#227b60",
  stopOpacity: ".06"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".92",
  stopColor: "#227b60",
  stopOpacity: "0"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "E",
  cx: "0",
  cy: "0",
  r: "1",
  gradientTransform: "rotate(88.6 7.65 20.636) scale(8.70283 6.17901)",
  href: "#l"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#227b60"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".36",
  stopColor: "#227b60",
  stopOpacity: ".63"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".92",
  stopColor: "#227b60",
  stopOpacity: "0"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "F",
  cx: "0",
  cy: "0",
  r: "1",
  gradientTransform: "rotate(88.6 7.59 21.075) scale(6.94103 4.44226)",
  href: "#l"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#20735a"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".15",
  stopColor: "#20745a",
  stopOpacity: ".93"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".38",
  stopColor: "#21755c",
  stopOpacity: ".74"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".67",
  stopColor: "#21785d",
  stopOpacity: ".43"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#227b60",
  stopOpacity: "0"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "G",
  cx: "0",
  cy: "0",
  r: "1",
  gradientTransform: "matrix(10.21955 4.50736 -3.3805 7.66464 29.403 14.08)",
  href: "#l"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#227a61"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".36",
  stopColor: "#227a61",
  stopOpacity: ".56"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".72",
  stopColor: "#227a61",
  stopOpacity: ".16"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".9",
  stopColor: "#227a61",
  stopOpacity: "0"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "H",
  cx: "0",
  cy: "0",
  r: "1",
  gradientTransform: "rotate(35.272 18.524 39.902) scale(14.8956 13.6199)",
  href: "#l"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#3cd9c3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".07",
  stopColor: "#3bd7c1",
  stopOpacity: ".9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".41",
  stopColor: "#38ceb9",
  stopOpacity: ".42"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".65",
  stopColor: "#36c8b4",
  stopOpacity: ".12"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".76",
  stopColor: "#35c6b2",
  stopOpacity: "0"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "I",
  cx: "0",
  cy: "0",
  r: "1",
  gradientTransform: "rotate(35.272 17106.468 16967.84) scale(2645.63 1857.08)",
  href: "#l"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#3cd9c3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".07",
  stopColor: "#3bd7c1",
  stopOpacity: ".9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".41",
  stopColor: "#38ceb9",
  stopOpacity: ".42"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".65",
  stopColor: "#36c8b4",
  stopOpacity: ".12"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".76",
  stopColor: "#35c6b2",
  stopOpacity: "0"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "J",
  cx: "0",
  cy: "0",
  r: "1",
  gradientTransform: "matrix(-2.50043 12.89725 -15.93744 -3.08984 32.376 16.652)",
  href: "#l"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#237f66",
  stopOpacity: ".8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".06",
  stopColor: "#2c8c70",
  stopOpacity: ".65"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".21",
  stopColor: "#3da785",
  stopOpacity: ".37"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".35",
  stopColor: "#4aba93",
  stopOpacity: ".17"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".47",
  stopColor: "#51c59c",
  stopOpacity: ".04"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".56",
  stopColor: "#54c99f",
  stopOpacity: "0"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "K",
  cx: "0",
  cy: "0",
  r: "1",
  gradientTransform: "rotate(-50.82 30.63 -16.719) scale(17.1667 18.5401)",
  href: "#l"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#167c8a"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".04",
  stopColor: "#167c8a",
  stopOpacity: ".93"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".33",
  stopColor: "#177f8d",
  stopOpacity: ".43"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".54",
  stopColor: "#17818f",
  stopOpacity: ".12"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".65",
  stopColor: "#178290",
  stopOpacity: "0"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "L",
  cx: "0",
  cy: "0",
  r: "1",
  gradientTransform: "rotate(-31.66 45.675 -31.268) scale(16.7468 13.23)",
  href: "#l"
}, /*#__PURE__*/React.createElement("stop", {
  offset: ".05",
  stopColor: "#177d87"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".11",
  stopColor: "#177e89",
  stopOpacity: ".8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".21",
  stopColor: "#177f8b",
  stopOpacity: ".52"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".32",
  stopColor: "#17818d",
  stopOpacity: ".29"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".42",
  stopColor: "#17818f",
  stopOpacity: ".13"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".51",
  stopColor: "#178290",
  stopOpacity: ".03"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".6",
  stopColor: "#178290",
  stopOpacity: "0"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "M",
  cx: "0",
  cy: "0",
  r: "1",
  gradientTransform: "rotate(-130.539 14.056 5.41) scale(9.97763 7.85659)",
  href: "#l"
}, /*#__PURE__*/React.createElement("stop", {
  offset: ".26",
  stopColor: "#177f8a"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".27",
  stopColor: "#177f8a",
  stopOpacity: ".98"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".38",
  stopColor: "#17808c",
  stopOpacity: ".68"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".5",
  stopColor: "#17818d",
  stopOpacity: ".43"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".62",
  stopColor: "#17818f",
  stopOpacity: ".24"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".74",
  stopColor: "#17828f",
  stopOpacity: ".11"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".86",
  stopColor: "#178290",
  stopOpacity: ".03"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#178290",
  stopOpacity: "0"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "N",
  cx: "0",
  cy: "0",
  r: "1",
  gradientTransform: "rotate(-173.11 9.3 10.511) scale(9.35929)",
  href: "#l"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#13656e"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".11",
  stopColor: "#13646e",
  stopOpacity: ".73"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".27",
  stopColor: "#12646e",
  stopOpacity: ".41"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".42",
  stopColor: "#12636e",
  stopOpacity: ".18"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".55",
  stopColor: "#12636e",
  stopOpacity: ".05"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".66",
  stopColor: "#12636e",
  stopOpacity: "0"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "O",
  cx: "0",
  cy: "0",
  r: "1",
  gradientTransform: "matrix(-3.20511 -5.70678 4.79369 -2.6923 17.025 23.456)",
  href: "#l"
}, /*#__PURE__*/React.createElement("stop", {
  offset: ".13",
  stopColor: "#146a73"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".24",
  stopColor: "#156f79",
  stopOpacity: ".79"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".45",
  stopColor: "#167783",
  stopOpacity: ".45"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".65",
  stopColor: "#167d8a",
  stopOpacity: ".2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".82",
  stopColor: "#17818e",
  stopOpacity: ".05"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".95",
  stopColor: "#178290",
  stopOpacity: "0"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "P",
  cx: "0",
  cy: "0",
  r: "1",
  gradientTransform: "matrix(3.44367 -5.10402 4.04351 2.72815 16.515 20.728)",
  href: "#l"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#198e9c"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".1",
  stopColor: "#198e9c",
  stopOpacity: ".87"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".41",
  stopColor: "#198e9c",
  stopOpacity: ".5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".67",
  stopColor: "#198e9c",
  stopOpacity: ".23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".88",
  stopColor: "#198e9c",
  stopOpacity: ".06"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#198e9c",
  stopOpacity: "0"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "W",
  cx: "0",
  cy: "0",
  r: "1",
  gradientTransform: "matrix(-3.10893 20.34068 -13.4249 -2.0519 34.648 15.382)",
  href: "#l"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#1a3d9c"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".4",
  stopColor: "#1a3d9c",
  stopOpacity: ".42"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".7",
  stopColor: "#1a3d9c",
  stopOpacity: "0"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "X",
  cx: "0",
  cy: "0",
  r: "1",
  gradientTransform: "matrix(-382.42109 2502.05355 -1349.34006 -206.23703 6053.6 10012.8)",
  href: "#l"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#1a3d9c"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".4",
  stopColor: "#1a3d9c",
  stopOpacity: ".42"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".7",
  stopColor: "#1a3d9c",
  stopOpacity: "0"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "Y",
  cx: "0",
  cy: "0",
  r: "1",
  gradientTransform: "rotate(98.616 -1830.43 6753.961) scale(3014.4 1245.56)",
  href: "#l"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#1a3d9c"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".4",
  stopColor: "#1a3d9c",
  stopOpacity: ".42"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".7",
  stopColor: "#1a3d9c",
  stopOpacity: "0"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "Z",
  cx: "0",
  cy: "0",
  r: "1",
  gradientTransform: "rotate(83.089 7.79 24.701) scale(17.9859 12.5494)",
  href: "#l"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#1a3d9c"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".16",
  stopColor: "#1a3d9c",
  stopOpacity: ".69"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".33",
  stopColor: "#1a3d9c",
  stopOpacity: ".4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".49",
  stopColor: "#1a3d9c",
  stopOpacity: ".18"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".61",
  stopColor: "#1a3d9c",
  stopOpacity: ".05"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".7",
  stopColor: "#1a3d9c",
  stopOpacity: "0"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "a",
  cx: "0",
  cy: "0",
  r: "1",
  gradientTransform: "matrix(4.5785 16.66759 -11.33396 3.11338 35.337 17.364)",
  href: "#l"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#18388f"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".37",
  stopColor: "#193b96",
  stopOpacity: ".45"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".7",
  stopColor: "#1a3d9c",
  stopOpacity: "0"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "b",
  cx: "0",
  cy: "0",
  r: "1",
  gradientTransform: "matrix(2.1288 7.74966 -7.36218 2.02235 33.615 21.971)",
  href: "#l"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#18388f"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".09",
  stopColor: "#183992",
  stopOpacity: ".78"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".22",
  stopColor: "#193b96",
  stopOpacity: ".5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".35",
  stopColor: "#193c98",
  stopOpacity: ".28"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".47",
  stopColor: "#1a3c9a",
  stopOpacity: ".13"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".59",
  stopColor: "#1a3d9c",
  stopOpacity: ".03"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".7",
  stopColor: "#1a3d9c",
  stopOpacity: "0"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "c",
  cx: "0",
  cy: "0",
  r: "1",
  gradientTransform: "matrix(2.1288 7.74966 -7.36218 2.02235 33.808 23.342)",
  href: "#l"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#1a3d9c",
  stopOpacity: ".8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".01",
  stopColor: "#1a3d9c",
  stopOpacity: ".78"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".24",
  stopColor: "#1a3d9c",
  stopOpacity: ".45"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".44",
  stopColor: "#1a3d9c",
  stopOpacity: ".2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".6",
  stopColor: "#1a3d9c",
  stopOpacity: ".05"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".7",
  stopColor: "#1a3d9c",
  stopOpacity: "0"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "d",
  cx: "0",
  cy: "0",
  r: "1",
  gradientTransform: "matrix(7.48565 17.65848 -11.7181 4.96745 13.01 18.608)",
  href: "#l"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#1a3d9c"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".4",
  stopColor: "#1a3d9c",
  stopOpacity: ".56"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".48",
  stopColor: "#1a3d9c",
  stopOpacity: ".43"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".69",
  stopColor: "#1a3d9c",
  stopOpacity: ".12"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".79",
  stopColor: "#1a3d9c",
  stopOpacity: "0"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "e",
  cx: "0",
  cy: "0",
  r: "1",
  gradientTransform: "rotate(76.103 -3.124 14.584) scale(14.2261 9.39196)",
  href: "#l"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#1a3d9c"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".06",
  stopColor: "#1a3d9c",
  stopOpacity: ".88"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".21",
  stopColor: "#1a3d9c",
  stopOpacity: ".61"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".36",
  stopColor: "#1a3d9c",
  stopOpacity: ".39"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".51",
  stopColor: "#1a3d9c",
  stopOpacity: ".22"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".67",
  stopColor: "#1a3d9c",
  stopOpacity: ".1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".83",
  stopColor: "#1a3d9c",
  stopOpacity: ".02"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#1a3d9c",
  stopOpacity: "0"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "f",
  cx: "0",
  cy: "0",
  r: "1",
  gradientTransform: "rotate(76.103 -3.124 14.584) scale(14.2261 9.39196)",
  href: "#l"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#1b3e9e"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".06",
  stopColor: "#1b3e9e",
  stopOpacity: ".87"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".21",
  stopColor: "#1b3e9d",
  stopOpacity: ".61"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".36",
  stopColor: "#1a3d9d",
  stopOpacity: ".39"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".52",
  stopColor: "#1a3d9c",
  stopOpacity: ".22"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".67",
  stopColor: "#1a3d9c",
  stopOpacity: ".1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".83",
  stopColor: "#1a3d9c",
  stopOpacity: ".02"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#1a3d9c",
  stopOpacity: "0"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "g",
  cx: "0",
  cy: "0",
  r: "1",
  gradientTransform: "matrix(2.61403 10.56502 -6.97494 1.72576 12.322 12.727)",
  href: "#l"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#183991"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".03",
  stopColor: "#183992",
  stopOpacity: ".95"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".18",
  stopColor: "#193a95",
  stopOpacity: ".66"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".34",
  stopColor: "#193b97",
  stopOpacity: ".42"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".5",
  stopColor: "#1a3c99",
  stopOpacity: ".24"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".66",
  stopColor: "#1a3d9b",
  stopOpacity: ".1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".82",
  stopColor: "#1a3d9c",
  stopOpacity: ".03"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#1a3d9c",
  stopOpacity: "0"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "h",
  cx: "0",
  cy: "0",
  r: "1",
  gradientTransform: "rotate(87.138 -.264 14.63) scale(8.60014 7.57069)",
  href: "#l"
}, /*#__PURE__*/React.createElement("stop", {
  offset: ".04",
  stopColor: "#2453d6",
  stopOpacity: ".6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".2",
  stopColor: "#2453d6",
  stopOpacity: ".49"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".52",
  stopColor: "#2453d6",
  stopOpacity: ".2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".73",
  stopColor: "#2453d6",
  stopOpacity: "0"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "A",
  x1: "2.061",
  y1: "22.234",
  x2: "37.838",
  y2: "7.773",
  href: "#l"
}, /*#__PURE__*/React.createElement("stop", {
  offset: ".13",
  stopColor: "#1cbbf3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".34",
  stopColor: "#1f99a5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".45",
  stopColor: "#209ca6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".51",
  stopColor: "#24a4aa"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".57",
  stopColor: "#2bb3b0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".6",
  stopColor: "#30bdb4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".79",
  stopColor: "#38ba90"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#60f05a"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Q",
  x1: "4.366",
  y1: "-.749",
  x2: "20.15",
  y2: "13.86",
  href: "#l"
}, /*#__PURE__*/React.createElement("stop", {
  offset: ".13",
  stopColor: "#2bf9ff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".27",
  stopColor: "#29f9ff",
  stopOpacity: ".64"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".4",
  stopColor: "#27faff",
  stopOpacity: ".3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".49",
  stopColor: "#26faff",
  stopOpacity: ".08"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".54",
  stopColor: "#26faff",
  stopOpacity: "0"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "R",
  x1: "-4.573",
  y1: "23.091",
  x2: "13.865",
  y2: "17.864",
  href: "#l"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#26faff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".06",
  stopColor: "#26faff",
  stopOpacity: ".88"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".24",
  stopColor: "#26faff",
  stopOpacity: ".51"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".39",
  stopColor: "#26faff",
  stopOpacity: ".23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".5",
  stopColor: "#26faff",
  stopOpacity: ".06"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".55",
  stopColor: "#26faff",
  stopOpacity: "0"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "S",
  x1: ".311",
  y1: "22.449",
  x2: "21.093",
  y2: "15.042",
  href: "#l"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#21deff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".04",
  stopColor: "#21deff",
  stopOpacity: ".88"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".17",
  stopColor: "#21deff",
  stopOpacity: ".51"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".27",
  stopColor: "#21deff",
  stopOpacity: ".23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".34",
  stopColor: "#21deff",
  stopOpacity: ".06"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".38",
  stopColor: "#21deff",
  stopOpacity: "0"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "T",
  x1: "20.058",
  y1: "11.729",
  x2: "31.681",
  y2: "30.686",
  href: "#l"
}, /*#__PURE__*/React.createElement("stop", {
  offset: ".62",
  stopColor: "#21deff",
  stopOpacity: "0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".66",
  stopColor: "#21deff",
  stopOpacity: ".06"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".73",
  stopColor: "#21deff",
  stopOpacity: ".23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".83",
  stopColor: "#21deff",
  stopOpacity: ".51"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".96",
  stopColor: "#21deff",
  stopOpacity: ".88"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#21deff"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "U",
  x1: "32.994",
  y1: "18.812",
  x2: "31.165",
  y2: "9.894",
  href: "#l"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#44b044"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".11",
  stopColor: "#44b044",
  stopOpacity: ".8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".27",
  stopColor: "#44b044",
  stopOpacity: ".52"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".43",
  stopColor: "#44b044",
  stopOpacity: ".29"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".58",
  stopColor: "#44b044",
  stopOpacity: ".13"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".7",
  stopColor: "#44b044",
  stopOpacity: ".03"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".8",
  stopColor: "#44b044",
  stopOpacity: "0"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "V",
  x1: "7.486",
  y1: "9.568",
  x2: "45.964",
  y2: "22.307",
  href: "#l"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#3066fb"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".38",
  stopColor: "#2f64f7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".74",
  stopColor: "#2857d9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#3c7eff"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "i",
  x1: "32.487",
  y1: "-6.143",
  x2: "22.768",
  y2: "17.88",
  href: "#l"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#3774ff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".05",
  stopColor: "#3774ff",
  stopOpacity: ".91"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".16",
  stopColor: "#3774ff",
  stopOpacity: ".66"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".32",
  stopColor: "#3774ff",
  stopOpacity: ".28"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".43",
  stopColor: "#3774ff",
  stopOpacity: "0"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "l",
  gradientUnits: "userSpaceOnUse"
}), /*#__PURE__*/React.createElement("path", {
  id: "j",
  d: "M10.486 16.633a26.68 26.68 0 002.056 5.133c.393.724.787 1.448 1.501 1.904.124.078.26.133.403.164 1.052.225 1.629-.623 2.001-1.397a23.026 23.026 0 001.339-3.77l.191-.724.345-1.393 4.643-12.405A10.345 10.345 0 0131.247.011c2.313-.014 4.562.76 6.376 2.196 3.036 2.298 4.844 6.823 4.844 6.823a4.57 4.57 0 01.398 1.873 4.55 4.55 0 01-1.34 3.216 4.55 4.55 0 01-3.221 1.326 4.532 4.532 0 01-3.483-1.633l-.043-.053a6.07 6.07 0 01-.724-1.274 17.53 17.53 0 00-.84-1.66 10.53 10.53 0 00-.536-.801 3.29 3.29 0 00-.572-.627c-.427-.345-.965-.483-1.467-.186a.766.766 0 00-.07.046c-.517.355-.878 1.072-1.13 1.622-.724 1.559-1.139 3.157-1.549 4.798l-.227.951-1.919 6.275-2.705 5.966a10.45 10.45 0 01-3.625 2.965 10.45 10.45 0 01-4.556 1.084c-6.572.14-9.69-5.792-9.69-5.792C1.424 20.984.321 12.885.058 10.295.002 9.757 0 9.436 0 9.436a4.458 4.458 0 012.377-3.942 4.891 4.891 0 012.399-.524 4.566 4.566 0 012.187.664 4.31 4.31 0 011.303 1.207c.618.878.758 1.972.881 3.017a41.189 41.189 0 001.339 6.774z"
}), /*#__PURE__*/React.createElement("path", {
  id: "k",
  d: "M41.458 4.99a4.53 4.53 0 00-1.137.142 21.78 21.78 0 012.145 3.9 4.57 4.57 0 01.398 1.873 4.55 4.55 0 01-.35 1.741 4.548 4.548 0 01-.99 1.475 4.55 4.55 0 01-3.221 1.326 4.562 4.562 0 01-2.298-.627l-.468 1.73c-.849 2.841-1.448 3.939-1.448 3.939a15.34 15.34 0 01-1.173 2.218c-.311.461-.71.924-1.255 1.101a1.26 1.26 0 01-.591.058 1.603 1.603 0 01-.611-.205 2.69 2.69 0 01-.83-1.033 14.66 14.66 0 01-.62-1.393c-.403-.98-1.026-3.393-1.026-3.393l-.644-2.527-.644-2.546-.459-1.672c-1.207-4.356-2.877-6.499-2.877-6.499A11.074 11.074 0 0018.035.534C15.54-.361 12.921.143 12.921.143c-4.103.806-6.258 3.62-7.207 4.974a4.65 4.65 0 011.233.521A4.31 4.31 0 018.25 6.845c.618.878.758 1.972.881 3.017a41.03 41.03 0 001.337 6.695c1.39-4.61 3.058-6.758 3.058-6.758.186-.232.41-.431.661-.589a1.09 1.09 0 01.43-.152 1.26 1.26 0 01.804.195.89.89 0 01.123.097c.218.193.405.419.555.668a14.44 14.44 0 01.9 1.931c.521 1.467.965 3.261.965 3.261l1.327 5.232c.965 3.557 1.784 5.286 1.784 5.286 2.015 4.614 5.097 5.913 5.097 5.913 1.5.802 3.169 1.239 4.87 1.274a10.147 10.147 0 004.697-1.011 11.956 11.956 0 004.115-3.328c.746-.864 1.844-2.969 1.844-2.969a38.08 38.08 0 002.836-7.561 48.356 48.356 0 001.035-4.943l.352-2.488a6.43 6.43 0 00-.072-2.372 3.546 3.546 0 00-.133-.413 4.485 4.485 0 00-2.032-2.29 4.677 4.677 0 00-2.228-.548z"
})));